import {assoc} from '@packages/utilities/fp/utils';

export type SeenComponents = Readonly<{
  [key: string]: symbol;
}>;

export const SYMBOL_COMPONENT_TYPE = Symbol('Symbol');
export const PLUGIN_COMPONENT_TYPE = Symbol('PluginComponent');

export function addSeenComponent(
  seenComponents: SeenComponents,
  symbolId: string,
  isSymbol: boolean
): SeenComponents {
  return assoc(symbolId)(
    isSymbol ? SYMBOL_COMPONENT_TYPE : PLUGIN_COMPONENT_TYPE
  )(seenComponents);
}

export const lastSeenComponentKind = (
  seenComponents: SeenComponents
): 'Symbol' | 'PluginComponent' | null => {
  const ids = Object.keys(seenComponents);
  // @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
  const lastSeen = seenComponents[ids[ids.length - 1]];
  if (!lastSeen) return null;
  return lastSeen === SYMBOL_COMPONENT_TYPE ? 'Symbol' : 'PluginComponent';
};
